import {Injectable} from '@angular/core'
import {BaseApiEndpointService} from '../../BaseApiEndpoint.service'
import {Backend, PaginatedResponse, SingleResponse} from "@generated-backend-types";
import {ListItem} from "ng-multiselect-dropdown/multiselect.model";
import CollectorCase = Backend.App.Http.Resources.Dashboard.Collectors.CollectorCase;
import DashboardCollectorCaseData = Backend.App.Data.Collector.Case.DashboardCollectorCaseData;
import CollectorCaseStateEnum = Backend.App.Enums.Orders.Collector.CollectorCaseStateEnum;
import {Observable} from "rxjs";
import Article = Backend.App.Http.Resources.Dashboard.Settings.Articles.Article;
import {take} from "rxjs/operators";
import Slot = Backend.App.Http.Resources.Dashboard.Bookings.Slot;
import {HttpContext, HttpParams } from "@angular/common/http";
import {USE_UUID_IDEMPOTENCY_KEY} from "../../../idempotency-context";

@Injectable({
  providedIn: 'root'
})
export class CasesService extends BaseApiEndpointService<CollectorCase, DashboardCollectorCaseData> {
  protected override endpoint = '/collectors/cases'
  public override readonly multiSelectSortBy = 'pickup_date'

  modelToMultiSelectItem(m: CollectorCase): ListItem & {
    model: CollectorCase
  } {
    return {
      id: m.id,
      text: m.collector_person?.guest?.first_name + ' ' + m.collector_person?.guest?.last_name + ' (' + m.pickup_date + ')' + (m.state !== CollectorCaseStateEnum.ACTIVE ? ' - (' + this.translateService.instant('enums.collectorCaseStateEnum.' + m.state) + ')' : ''),
      isDisabled: false,
      model: m,
    }
  }

  public indexArticle(id: string, page: number = 1, params?: HttpParams | {
    [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  }): Observable<PaginatedResponse<Article>> {
    return this.http.get<PaginatedResponse<Article>>(this.endpoint + '/' + id + '/articles',
      {
        params: {
          ...params,
          page
        }
      }).pipe(take(1));
  }

  public getArticle(id: string, articleId: string): Observable<SingleResponse<Article>> {
    return this.http.get<SingleResponse<Article>>(this.endpoint + '/' + id + '/articles/' + articleId).pipe(take(1));
  }

  public indexSlot(id: string, page: number = 1, params?: HttpParams | {
    [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  }): Observable<PaginatedResponse<Slot>> {
    return this.http.get<PaginatedResponse<Slot>>(this.endpoint + '/' + id + '/slots',
      {
        params: {
          ...params,
          page
        }
      }).pipe(take(1));
  }

  public getSlot(id: string, slotId: string): Observable<SingleResponse<Slot>> {
    return this.http.get<SingleResponse<Slot>>(this.endpoint + '/' + id + '/slots/' + slotId).pipe(take(1));
  }

  public sendDayProgramDateEmail(caseId: string, emailId: string, emailData: Backend.App.Data.Orders.DashboardOrderEmailData): Observable<SingleResponse<unknown>> {
    return this.http.post<SingleResponse<unknown>>(this.endpoint + `/${caseId}/email/${emailId}/send`, emailData).pipe(take(1));
  }

  public previewDayProgramDateEmail(caseId: string, emailId: string, emailData: Backend.App.Data.Orders.DashboardOrderEmailData): Observable<string> {
    return this.http.post(
      this.endpoint + `/${caseId}/email/${emailId}/preview`,
      emailData,
      {responseType: 'text', context: new HttpContext().set(USE_UUID_IDEMPOTENCY_KEY, true)}
    ).pipe(take(1));
  }
}
